import { Id, useAppNotification } from '@feature/utils';

import { MinStdIndicatorItemForm } from './form/MinStdIndicatorItemForm';
import { useMinStdAddIndicatorItem } from './model/MinStdQuery';
import { IndicatorItemRequest, MinStdIndicatorType } from './model/MinStdTypes';

interface MinStdIndicatorItemCreateProps {
  close: () => void;

  authorId: Id;
  indicatorCode: string;
  year: number | null;

  indicatorType: MinStdIndicatorType;

  legend: string | null;

  alreadySelectedIds: number[];
  showPointsField: boolean;
}

export function MinStdIndicatorItemCreate(props: MinStdIndicatorItemCreateProps) {
  const { close, authorId, indicatorCode, indicatorType, legend, alreadySelectedIds, year, showPointsField } = props;
  const { mutate, isPending } = useMinStdAddIndicatorItem(authorId, indicatorCode);
  const notification = useAppNotification();
  const defaultValues = {
    link: '',
    note: '',
    activityDescription: '',
    number: 0,
    year,
    indicatorType,
  };

  const onSubmit = (values: IndicatorItemRequest) => {
    mutate(
      {
        ...values,
        year,
        indicatorType,
      },
      {
        onSuccess: () => {
          notification.success();
          close();
        },
        onError: notification.error,
      },
    );
  };

  return (
    <MinStdIndicatorItemForm
      onCancel={close}
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      indicatorType={indicatorType}
      legend={legend}
      authorId={authorId}
      indicatorCode={indicatorCode}
      alreadySelectedIds={alreadySelectedIds}
      year={year}
      showPointsField={showPointsField}
    />
  );
}
